import { GET_TRANSLATIONS_REQUEST } from '../../Constants/ReduxKeys';

export function getTranslations(bool) {
  return {
    type: GET_TRANSLATIONS_REQUEST,
    payload: { isShowFlagSpinner: bool }
  };
};

